"use client";

import { useState } from "react";

export default function LoginForm() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // Se leen los campos al enviar, no desde el estado de React: cuando el navegador
    // autocompleta el usuario y la clave guardados, muestra los valores pero no avisa a
    // la página hasta que hay una interacción, y el primer intento salía vacío.
    const form = new FormData(event.currentTarget);
    const user = String(form.get("user") || "");
    const password = String(form.get("password") || "");
    setLoading(true);
    setError("");
    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user, password }),
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok || !json.ok) {
        setError(json.error || "Credenciales inválidas");
        setLoading(false);
        return;
      }
      // Navegación completa: el panel se carga con la cookie recién creada y el botón
      // sigue en "Entrando…" hasta que aparece, para que no inviten a pulsar otra vez.
      window.location.assign("/");
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : "No se pudo iniciar sesión");
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4">
      <label className="block space-y-2">
        <span className="text-sm text-white/70">Usuario</span>
        <input name="user" autoComplete="username" className="w-full rounded-xl border border-white/10 bg-black/30 px-4 py-3 text-sm text-white outline-none placeholder:text-white/30 focus:border-cyan-400/40" placeholder="demo" />
      </label>
      <label className="block space-y-2">
        <span className="text-sm text-white/70">Clave</span>
        <input name="password" type="password" autoComplete="current-password" className="w-full rounded-xl border border-white/10 bg-black/30 px-4 py-3 text-sm text-white outline-none placeholder:text-white/30 focus:border-cyan-400/40" placeholder="••••••••" />
      </label>
      {error ? <div className="rounded-xl border border-rose-500/25 bg-rose-500/10 p-3 text-sm text-rose-100">{error}</div> : null}
      <button type="submit" disabled={loading} className="w-full rounded-xl border border-cyan-400/30 bg-cyan-500/10 px-4 py-3 text-sm font-medium text-white hover:bg-cyan-500/20 disabled:opacity-60">
        {loading ? "Entrando…" : "Entrar"}
      </button>
    </form>
  );
}
